import * as React from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import hasFeature from 'modules/core/lib/hasFeature'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import WorkScheduleSettings from 'modules/work_schedules/components/WorkScheduleSettings'
import type { RouteContextParams } from 'modules/work_schedules/lib/RouteContextParams'
import { RedirectToWorkScheduleListPage } from 'modules/work_schedules/pages/settings/RedirectToWorkScheduleListPage'

const WorkScheduleEditPage = () => {
  const {
    back,
    workSchedule,
    isNotFound,
    defaultPeriod,
    overlapPeriods,
    dayConfigurations,
    loading,
  } = useOutletContext<RouteContextParams>()

  const { loading: contractVersionsLoading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  if (!hasFeature('dev_fixed_work_schedules') && defaultPeriod?.isFixed) {
    return <RedirectToWorkScheduleListPage />
  }

  return (
    <WorkScheduleSettings
      workSchedule={workSchedule}
      dayConfigurations={dayConfigurations}
      periodLoading={loading}
      defaultPeriod={defaultPeriod}
      contractVersions={contractVersions}
    >
      <Outlet
        context={{
          back,
          workSchedule,
          isNotFound,
          defaultPeriod,
          overlapPeriods,
          dayConfigurations,
          loading: loading || contractVersionsLoading,
        }}
      />
    </WorkScheduleSettings>
  )
}

export default observer(WorkScheduleEditPage)
